module.exports = __webpack_public_path__ + "static/img/climb.cf6ad173.png";